module.exports = __webpack_public_path__ + "img/multi_d.b9721866.svg";